export default function () {
  const event = document.createEvent('MouseEvents');
  event.initMouseEvent('mousedown', true, true, window);

  document.body.dispatchEvent(event);
}
